import { render } from "./verifyotp.vue?vue&type=template&id=34439c94"
import script from "./verifyotp.vue?vue&type=script&lang=js"
export * from "./verifyotp.vue?vue&type=script&lang=js"

import "./verifyotp.vue?vue&type=style&index=0&id=34439c94&lang=css"

import exportComponent from "C:\\Users\\Eduardo\\Documents\\RadSystems\\PHPRad Projects\\zendata\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__